import {TableViews} from "./Tables/TableViews";
import {Alerts} from "./Alerts";

export class StockTake {
    static init() {
        StockTake.onChangeOnStockItem();
    }

    static onChangeOnStockItem() {
        $('.stock-take-item').change((event) => {
            const $element = $(event.currentTarget);
            const stockLocation = location.pathname.split('/')[3];
            axios.post(`/api/stock-locations/${stockLocation}/stock-take`, {
                items: {
                    0: {
                        product_id: $element.data('product-id'),
                        quantity: $element.val(),
                    }
                }
            })
                .then(() => {
                    Alerts.success('Stock Updated')
                })
                .catch(() => {
                    alert('There was an issue');
                });
        });
    }
    //
    // static onClickOfReset() {
    //     $('#btnResetStockTake').click(() => {
    //         localStorage.setItem('stock-take-items', null);
    //         location.reload();
    //     });
    // }
    //
    // static checkIfLocalStoragePresent() {
    //     return localStorage.getItem('stock-take-items') != 'null' && typeof localStorage.getItem('stock-take-items') == 'string';
    // }
    //
    // static checkToShowResetButton() {
    //     if (StockTake.checkIfLocalStoragePresent()) {
    //         $('#btnResetStockTake').show();
    //         $('#btnCompleteStockTake').show();
    //     } else {
    //         $('#btnResetStockTake').hide();
    //         $('#btnCompleteStockTake').hide();
    //     }
    // }
    //
    // static getFromLocalStorage(id) {
    //     const stockTakeItems = JSON.parse(localStorage.getItem('stock-take-items')) ?? {};
    //     if (!stockTakeItems.hasOwnProperty(id))
    //         return false;
    //     else
    //         return stockTakeItems[id];
    // }
    //
    // static addToLocalStorage($element) {
    //     const stockTakeItems = JSON.parse(localStorage.getItem('stock-take-items')) ?? {};
    //     stockTakeItems[$element.data('product-id')] = {};
    //     stockTakeItems[$element.data('product-id')]['quantity'] = $element.val();
    //     stockTakeItems[$element.data('product-id')]['total_cost'] = $element.val() * $element.data('cost-per-unit');
    //     StockTake.updateCostOnChange($element, TableViews.monetary(stockTakeItems[$element.data('product-id')]['total_cost']));
    //
    //     localStorage.setItem('stock-take-items', JSON.stringify(stockTakeItems));
    // }
    //
    // static removeFromLocalStorage($element) {
    //     const stockTakeItems = JSON.parse(localStorage.getItem('stock-take-items')) ?? {};
    //     delete stockTakeItems[$element.data('product-id')];
    //
    //     localStorage.setItem('stock-take-items', JSON.stringify(stockTakeItems));
    // }
    //
    // static updateCostOnChange($element, cost) {
    //     $(`#total_cost_${$element.data('product-id')}`).text(cost);
    // }
    //
    // static formatLocalStorageToSend() {
    //     const stockTakeItems = JSON.parse(localStorage.getItem('stock-take-items')) ?? {};
    //     const formData = {};
    //     Object.keys(stockTakeItems).map((itemId, key) => {
    //         formData[key] = {
    //             product_id: itemId,
    //             quantity: stockTakeItems[itemId].quantity
    //         }
    //     });
    //
    //     return formData;
    // }
    //
    // static onCompleteStockTake() {
    //     $('#btnCompleteStockTake').unbind('click').bind('click', () => {
    //         if (confirm("Are you sure to update stock?")) {
    //             const formData = StockTake.formatLocalStorageToSend();
    //             const stockLocation = location.pathname.split('/')[3];
    //             axios.post(`/api/stock-locations/${stockLocation}/stock-take`, {items: formData})
    //                 .then(() => {
    //                     localStorage.setItem('stock-take-items', null);
    //                     // location.reload();
    //                 })
    //                 .catch(() => {
    //                     alert('There was an issue');
    //                 });
    //         }
    //     });
    // }
}
